import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();
    let firstPartOfPath = pathname.split('/')[1];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [firstPartOfPath]);

    return null;
}